<!-- main sidenav for non-mobile -->
<div class="hide-small">
    <ng-container *ngTemplateOutlet="sidenavContent"></ng-container>
</div>

<!-- mobile side nav sent to sidebar via portal -->
<ng-template #mobileSidenavContent>
    <ng-container *ngTemplateOutlet="sidenavContent"></ng-container>
</ng-template>

<!-- main sidenav content in a template so we can re-use on desktop and mobile  -->
<!-- if you change anything here, make sure it is good on mobile too -->
<ng-template #sidenavContent>
    <div class="margin-bottom-3">
        <a (click)="closeSideNav()" class="back" routerLink="/company-onboarding">
            <mat-icon svgIcon="chevronLeft"></mat-icon>
            {{ 'self-serve.backToQuickstartGuide' | translate }}
        </a>
    </div>

    <div *ngFor="let group of navGroups">
        <h2 class="group-title margin-bottom-2">{{ group.title | translate }}</h2>

        <div
            *ngFor="let step of group.steps"
            class="step margin-bottom-2"
            routerLinkActive="active"
            [ngClass]="{ complete: step.complete }"
        >
            <div class="bulletWrapper">
                <mat-icon *ngIf="step.complete" svgIcon="success" class="checkmark"></mat-icon>
                <div *ngIf="!step.complete" class="bullet circle"></div>
            </div>
            <div class="link">
                <a (click)="closeSideNav()" [routerLink]="step.href"> {{ step.text | translate }} </a>
            </div>
        </div>
    </div>
</ng-template>
